import React from 'react';
import {
  Backdrop, Fade, makeStyles, IconButton, Modal, Checkbox, FormControlLabel, withStyles,
} from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import image from '../images/popup.png';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBody: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    position: 'relative',
    outline: 'none',

    [theme.breakpoints.up('sm')]: {
      width: '30%',
    },
  },
  modalCloseButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  checkbox: {
    color: 'white',
    fontWeight: 'bold !important',
  },
  closDesc: {
    color: 'white',
    fontWeight: 'bold',
  },
}));

const StyledFormControlLabel = withStyles({
  label: {
    color: 'white',
    fontWeight: 'bold',
  },
})(FormControlLabel);

const StyledCheckbox = withStyles({
  root: {
    '&$checked': {
      color: 'white',
    },
    path: {
      fill: 'white',
    },
  },
  checked: {},
})(Checkbox);

export default ({ isOpen, onClose, onCheckboxChange }) => {
  const classes = useStyles();

  return (
    <Modal
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.modal}
      closeAfterTransition
      onClose={onClose}
      open={isOpen}
    >
      <Fade in={isOpen}>
        <div className={classes.modalBody}>
          <div className={classes.modalCloseButton}>
            <IconButton
              style={{ padding: 0 }}
              disableRipple
              onClick={onClose}
            >
              <HighlightOffIcon style={{ fontSize: 32 }} />
            </IconButton>
          </div>
          <a href="/activity/ooha" target="_blank">
            <img src={image} alt="" width="100%" />
          </a>
          <StyledFormControlLabel
            label="下次不要再顯示"
            onChange={onCheckboxChange}
            control={<StyledCheckbox />}
          />
          <div className={classes.closDesc}>點擊空白處關閉活動資訊</div>
        </div>
      </Fade>
    </Modal>
  );
};
